<template>
  <div class="developers">
    <h4>{{ $t('Наименование') }}</h4>
    <ul class="developer-list" v-show="showArchive === false" v-if="successorDevelopers.length > 0">
      <li
        v-for="developer in successorDevelopers"
        :key="developer.developer.id"
      >
        <DeveloperTreeNode :node="developer" />
      </li>
    </ul>
    <ul class="developer-list" v-show="showArchive === true" v-if="developers.length > 0">
      <li
        v-for="developer in developers"
        :key="developer.developer.id"
      >
        <DeveloperTreeNode :node="developer" />
      </li>
    </ul>
    <a
      v-show="showArchive === true"
      @click="showArchive = false"
      v-if="successorDevelopers.length > 0"
    >
      {{ $t('Разработчики') }}
    </a>
    <a
      v-show="showArchive === false"
      @click="showArchive = true"
      v-if="developers.length > 0"
    >
      {{ $t('Архив разработчиков') }}
    </a>
  </div>
</template>

<script>
import CMS from '@/model/cms'
import DeveloperTreeNode from '@/components/widget/DeveloperTreeNode'

export default {
  components: {
    DeveloperTreeNode
  },
  props: {
    widget: Object
  },
  data: () => ({
    developers: [],
    successorDevelopers: [],
    showArchive: false
  }),
  created() {
    CMS.getNpaDeveloper()
      .then((response) => {
        this.developers = response.data.items
        this.successorDevelopers = response.data.successorItems
      })
      .catch((error) => {
        //@todo ошибки
      })
  }
}
</script>

<style>
.developers {
  transition: all 0.2s;
}

.developer-list {
  padding: 0 !important;
}

.slide-right-leave-to {
  opacity: 0;
  transform: translate(30px, 0);
}

.slide-right-enter {
  opacity: 0;
  transform: translate(-30px, 0);
}

.child-toggle-link {
  display: inline-block;
  cursor: pointer;
}

.developers .child-toggle-link {
  color: #0069bb !important;
  text-decoration: underline !important;
}

.developers .child-toggle-link:hover {
  color: #00508f !important;
}
</style>
